import { v4 as uuidv4 } from 'uuid'
import { isEmpty } from 'lodash-es'
import moment, { MomentInput } from 'moment'
import { DateLike } from './types'

// Synced Interval

let timerId: NodeJS.Timer | null = null
let callbacks: Record<string, Function> = {}
let lastCalled = 0

export function syncedInterval(callback: Function) {
  if (!timerId) {
    timerId = setInterval(handleTick, 100)
  }

  const intervalId = uuidv4()
  callbacks[intervalId] = callback
  return intervalId
}

export function clearSyncedInterval(intervalId: string) {
  delete callbacks[intervalId]
  if (isEmpty(callbacks) && timerId !== null) {
    clearInterval(timerId)
    timerId = null
    lastCalled = 0
  }
}

function handleTick() {
  const currentTime = Date.now()
  const missedCall = currentTime - lastCalled > 1150 && lastCalled !== 0
  const shouldCall = currentTime % 1000 < 100 && currentTime - lastCalled >= 100

  if (shouldCall || missedCall) {
    Object.values(callbacks).forEach(callback => callback())
    lastCalled = currentTime
  }
}

// Other Time Utils

export const getTimeLeft = (endTime: MomentInput): number => {
  const timeLeft = moment(endTime).diff(moment())
  return timeLeft > 0 ? timeLeft : 0
}

export const getValidUntilTime = (serverOffset: number, durationMins: number | null): string | null => {
  return durationMins !== null
    ? moment()
        .add(durationMins, 'minutes')
        .subtract(serverOffset, 'ms')
        .toISOString()
    : null
}

export function padNumberStart(num: number, length: number) {
  return num.toString().padStart(length, '0')
}

export function getFormattedTime(timeLeft: number): string {
  const momentTime = moment.duration(timeLeft)
  const paddedHours = padNumberStart(momentTime.hours(), 2)
  const paddedMins = padNumberStart(momentTime.minutes(), 2)
  const paddedSeconds = padNumberStart(momentTime.seconds(), 2)
  return `${paddedHours}:${paddedMins}:${paddedSeconds}`
}

export function getMinTime(timeList: DateLike[]): DateLike | null {
  return timeList.length > 0 ? timeList.reduce((minTime, time) => (moment(minTime).isBefore(moment(time)) ? minTime : time)) : null
}
